$.fn.Banque = function(_g) {
	var _bank = this;
	_bank.selectToggle = false;
	_bank.selectingAll = false;
	_bank.el = {
		checkboxes: _bank.find('input[type=checkbox]'),
		select_all: _bank.find('.btn-action-select-all'),
		save_btn: _bank.find('.btn-action-banque-save'),
	};

	_bank.selectAll = function() {
		_bank.selectingAll = true;
		if (!_bank.selectToggle){
			_bank.selectToggle = true;
			_bank.el.checkboxes.prop('checked', true).change();
			_bank.displayUnselectAllButton();
		} else {
			_bank.selectToggle = false;
			_bank.el.checkboxes.prop('checked', false).change();
			_bank.displaySelectAllButton();
		}
		_bank.selectingAll = false;
	};

	_bank.displaySelectAllButton = function() {
		_bank.el.select_all.find('span:not(.material-symbols-outlined)').text("Sélectionner tout");
		// _bank.el.select_all.find('i').removeClass("fa-close").addClass("fa-check");
	};

	_bank.displayUnselectAllButton = function() {
		_bank.el.select_all.find('span:not(.material-symbols-outlined)').text("Désélectionner tout");
		// _bank.el.select_all.find('i').removeClass("fa-check").addClass("fa-close");
	};

	_bank.changed = function() {
		if (!_bank.selectingAll) {
			var allSelected = true;
			_bank.el.checkboxes.each(function() {
				if (!$(this).prop('checked')) {
					allSelected = false;
				}
			});
			if (allSelected) {
				_bank.selectToggle = true;
				_bank.displayUnselectAllButton();
			} else {
				_bank.selectToggle = false;
				_bank.displaySelectAllButton();
			}
		}
	};

	_bank.save = function() {
		var bank_guarantees = [];
		_bank.el.checkboxes.each(function() {
			if ($(this).prop('checked')) {
				bank_guarantees.push($(this).attr("name"));
			}
		});
		_g.setBanqueDetails(bank_guarantees.join(","));
		_bank.modal('hide');
	};

	return function() {
		// initialize checkboxes
		_bank.el.select_all.on('click', _bank.selectAll);
		_bank.el.checkboxes.each(function() {
			$(this).on("change", _bank.changed);
		});
		_bank.el.save_btn.on('click', _bank.save);

		// load checked details
		_bank.selectingAll = true;
		_g.getBanqueDetails().forEach(function(x) {
			_bank.find('input[name="' + x + '"]').prop('checked', true).change();
		});
		_bank.selectingAll = false;
		_bank.changed();
		return _bank;
	}();
};
